import { css } from 'styled-components';
import { transparentize } from 'utils/color';

export function getCustomScrollbars(bgColor) {
  return css`
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
      background-color: ${bgColor || 'transparent'};
    }

    &::-webkit-scrollbar-thumb {
      margin-right: 8px;
      background-color: ${transparentize('#191919', 0.2)};
      border-radius: 6px;
    }
  `;
}
export default getCustomScrollbars;
